import {Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component ({
  selector: 'checkbox-ui',
  template: '' +
  '<input id="custom-checkbox" type="checkbox" [(ngModel)]="boxModel" (change)="change(boxModel)">' +
  '<label for="custom-checkbox"><span>{{title}}</span></label>',
  styleUrls: ['checkbox-ui.component.sass']
})
export class CheckBoxUiComponentUIComponent implements OnInit {
  @Input() public title: string;
  @Input() boxModel: boolean;
  @Output() changeBox = new EventEmitter();

  constructor() { }

  change(boxModel: boolean) {
    this.changeBox.emit(boxModel);
  }

  ngOnInit () {
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/MZoVYbaM/0/has-gas/lora-wan/lora-ui/src/app/components/checkbox/checkbox-ui.component.ts